import React, { Component, Context } from "react";
import { connect } from "react-redux";
import clsx from "clsx";
import { IDirectorActionDispatches, mapDirectorDispatchToProps } from "../../../redux/actions/director";
import { IDirectorState, mapDirectorStateToProps } from "../../../redux/reducers/director";
import { WidgetProps } from "..";
import { IDirector } from "../../../laco-common/base/models/director";
import LayoutContext, { ILayoutContext } from "../../../contexts/layout/LayoutContext";
import UILoader from "../../ui/UILoader";
import ImageEnlarge from "../../ui/Media/ImageEnlarge";
import { sortBy } from "../../../utils";
import { PhoneLinkWeb } from "../../ui/PhoneLinkWeb";
import { EmailLinkWeb } from "../../ui/EmailLinkWeb";
import { FileType } from "../../../laco-common/base/models/IFile";

class Officers extends Component<IDirectorActionDispatches & IDirectorState & WidgetProps> {
	static contextType: Context<ILayoutContext> = LayoutContext;

	state = {
		loading: true,
	};

	componentDidMount() {
		this.props.loadDirectors().finally(() => {
			this.setState({ loading: false });
		});
	}

	render() {
		const featuredOfficers: IDirector[] = sortBy(
			(this.props.directors || []).filter((d: IDirector) => d.feature),
			"order"
		);
		return (
			<div className="bg-gray1">
				<div
					className={clsx(
						!this.props.isNested && "container",
						"directors-container d-flex flex-column",
						!this.props.page?.noPadding && "section-padding"
					)}
				>
					<h1 className="highlighted mb-4">Our Officers</h1>
					{this.state.loading && <UILoader display={true} />}

					{/* <div key={profile.id} style={{ maxWidth: imageDimensions.imageWidth }} className="mb-5"> */}
					<div className="d-flex flex-column flex-sm-row flex-wrap justify-content-between">
						{(featuredOfficers || []).map((director: IDirector, i: number) => {
							return (
								<div key={i} className="mb-5 mb-0-xl featured-item mt-2">
									<ImageEnlarge
										image={{
											title: director.name,
											url: director.imageUrl,
											filename: director.imageUrl,
											fileType: FileType.IMAGE,
											order: i,
											preview: false,
										}}
										hideHover={true}
										width={259}
										height={170}
									/>
									<h4 className="mb-1 mt-4">{director.assignment}</h4>
									<h3 className="subheading text-black">{director.name}</h3>
									<div className="text-sm gray-link inner-link">
										<EmailLinkWeb email={director.email} />
									</div>
									<div className="text-sm mt-1 gray-link inner-link">
										<PhoneLinkWeb number={director.phone} />
									</div>
								</div>
							);
						})}
					</div>
				</div>
			</div>
		);
	}
}

export default connect<IDirectorState, IDirectorActionDispatches, WidgetProps>(
	mapDirectorStateToProps,
	mapDirectorDispatchToProps
)(Officers);
